// Generated by Melange

import * as Buhta_cabinet__Box from "../../components/html/Box.js";
import * as Buhta_cabinet__Button from "../../components/html/Button.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__Auth from "../../../../../packages/core/lib/Auth.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function AuthConfirm(Props) {
  const match = Buhta_core__Auth.IdentityContext.useIdentity(undefined);
  const identity = match[0];
  let tmp;
  if (typeof identity === "number") {
    tmp = JsxRuntime.jsx(React.Fragment, {
          children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                className: "text-gray-medium",
                children: "Вы не авторизованы"
              })
        });
  } else {
    const profile = identity._0;
    const last_name = profile.last_name;
    const first_name = profile.first_name;
    tmp = JsxRuntime.jsxs(React.Fragment, {
          children: [
            JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                  className: "text-gray-medium",
                  children: [
                    "Подтвердите чтобы продолжить как ",
                    JsxRuntime.jsx(Buhta_components__Text.Span.make, {
                          className: "text-black",
                          children: "" + first_name + " " + last_name
                        })
                  ]
                }),
            JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                                kind: "default",
                                isWide: true,
                                onClick: (function (param) {
                                    ((window.location.href = '/auth/logout'
                                      ));
                                  }),
                                children: "Выйти"
                              }),
                          JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                                kind: "primary",
                                name: "submit",
                                value: "accept",
                                type_: "button",
                                isWide: true,
                                onClick: (function (param) {
                                    ((window.location.href = '/sso'
                                      ));
                                  }),
                                children: "Продолжить"
                              })
                        ],
                        className: "flex space-x-3 mt-4"
                      }),
                  className: "mt-8"
                })
          ]
        });
  }
  return JsxRuntime.jsx(Buhta_cabinet__Box.make, {
              title: "Вход",
              className: "relative",
              children: tmp
            });
}

const make = AuthConfirm;

export {
  make ,
}
/* Buhta_cabinet__Box Not a pure module */
